module.exports = __webpack_public_path__ + "assets/scooter_dark.6e05399e.svg";